import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  panelDetails: {
    padding: 0,
  },
  panelSummary: {
    padding: `0 ${theme.spacing(2)}px`,
  },
}));

export default useStyles;
